import { LOCAL_STORAGE } from 'app/localStorageManager'
import useLogger from 'lib/util/useLogger'

const debug = useLogger('getSignature', 'violet')

/**
 * Get the signature
 *
 * @param {string} message - the message
 * @param {object} signer - the signer
 * @returns {string?} the result or null if fail
 */
const getSignature = async (message, signer) => {
  const signatureCache = localStorage.getItem(LOCAL_STORAGE.signatureCache)
  const signatureMessageCache = localStorage.getItem(
    LOCAL_STORAGE.signatureMessageCache
  )

  if (!signer) {
    // Fail
    return null
  }

  if (signatureCache && signatureMessageCache === message && signer?.useCache) {
    // Match & use cache, return cache
    debug.log('Using signature cache for wallet', message, signatureCache)

    return signatureCache
  }

  debug.log('Getting signature from signer', signer)

  const signature = await signer.signMessage({ message })

  debug.log('Got signature from signer', signature, message)
  localStorage.setItem(LOCAL_STORAGE.signatureCache, signature)
  localStorage.setItem(LOCAL_STORAGE.signatureMessageCache, message)

  return signature
}

// Export
export default getSignature
